"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CoreQuadOperation {
    constructor(context, shader, shaderOwner, renderTextureInfo, scissor, index) {
        this.context = context;
        this.shader = shader;
        this.shaderOwner = shaderOwner;
        this.renderTextureInfo = renderTextureInfo;
        this.scissor = scissor;
        this.index = index;
        this.length = 0;
    }
    get quadList() {
        return this.context.renderState.quadList;
    }
    getTexture(index) {
        return this.quadList.getTexture(this.index + index);
    }
    getElementCore(index) {
        return this.quadList.getElementCore(this.index + index);
    }
    getElement(index) {
        return this.quadList.getElement(this.index + index);
    }
    getElementWidth(index) {
        return this.getElement(index).renderWidth;
    }
    getElementHeight(index) {
        return this.getElement(index).renderHeight;
    }
    getTextureWidth(index) {
        return this.quadList.getTextureWidth(this.index + index);
    }
    getTextureHeight(index) {
        return this.quadList.getTextureHeight(this.index + index);
    }
    getRenderWidth() {
        if (this.renderTextureInfo) {
            return this.renderTextureInfo.w;
        }
        else {
            return this.context.stage.w;
        }
    }
    getRenderHeight() {
        if (this.renderTextureInfo) {
            return this.renderTextureInfo.h;
        }
        else {
            return this.context.stage.h;
        }
    }
}
exports.CoreQuadOperation = CoreQuadOperation;
//# sourceMappingURL=CoreQuadOperation.js.map